import { IUserNotificationCategory } from '~/@api/generated-api-types-user/Api'
import { NotificationBanner } from '~/@mid_ui/notification-banner/NotificationBanner'
import { useUser } from '~/@biz_account/useUser/useUser'
import { EmailVerificationDialog } from './EmailVerificationDialog'
import { useState } from 'react'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'

function EmailVerificationBanner() {
  const isDesktop = useIsDesktop()
  const { user } = useUser()

  const [isDialogOpen, setIsDialogOpen] = useState(false)

  function handleCloseDialog() {
    setIsDialogOpen(false)
  }

  const isEmailVerified = user?.hasVerifiedEmail ?? false
  if (isEmailVerified) return null

  return (
    <>
      <NotificationBanner
        category={IUserNotificationCategory.Warning}
        type="emailVerification"
        message={
          isDesktop
            ? 'Vaša e-mailová adresa ešte nie je overená. Overiť ju môžete kliknutím na link alebo zadaním kódu, ktorý nájdete v e-maili.'
            : 'Vaša e-mailová adresa ešte nie je overená.'
        }
        closeText="Zadať overovací kód"
        onClick={() => setIsDialogOpen(true)}
      />
      <EmailVerificationDialog
        isDialogOpen={isDialogOpen}
        handleCloseDialog={handleCloseDialog}
      />
    </>
  )
}

export { EmailVerificationBanner }
